import { Controller } from "@hotwired/stimulus"

// Shared mobile drawer used by header hamburger.
// All controllers that share the same `data-controller="menu"` scope see the same
// drawer target because Stimulus scopes are per-element. We instead use a
// document-level event bus to toggle the drawer regardless of which trigger fires.
export default class extends Controller {
  static targets = ["drawer"]

  connect() {
    if (this.hasDrawerTarget) {
      this._boundOpen = () => this.show()
      this._boundClose = () => this.hide()
      document.addEventListener("menu:open", this._boundOpen)
      document.addEventListener("menu:close", this._boundClose)
    }
  }

  disconnect() {
    if (this._boundOpen) {
      document.removeEventListener("menu:open", this._boundOpen)
      document.removeEventListener("menu:close", this._boundClose)
    }
  }

  open() {
    if (this.hasDrawerTarget) {
      this.show()
    } else {
      document.dispatchEvent(new CustomEvent("menu:open"))
    }
  }

  close() {
    if (this.hasDrawerTarget) {
      this.hide()
    } else {
      document.dispatchEvent(new CustomEvent("menu:close"))
    }
  }

  show() {
    this.drawerTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    this.setExpanded(true)
    this.drawerTarget.querySelector("button[aria-label='Fermer']")?.focus()
  }

  hide() {
    this.drawerTarget.classList.add("hidden")
    document.body.style.overflow = ""
    this.setExpanded(false)
    document.querySelector("[data-menu-trigger]")?.focus()
  }

  // Garde aria-expanded du burger à jour.
  setExpanded(value) {
    document.querySelectorAll("[data-menu-trigger]").forEach((el) => el.setAttribute("aria-expanded", String(value)))
  }
}
